import api from "./api";

const customerMeasurementService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/customer-measurements", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/customer-measurements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getByCustomer(customerId) {
    try {
      const response = await api.get(`/customer-measurements/customer/${customerId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getByCustomerAndCategory(customerId, garmentCategory) {
    try {
      const response = await api.get(
        `/customer-measurements/customer/${customerId}/${encodeURIComponent(garmentCategory)}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(data) {
    try {
      const response = await api.post("/customer-measurements", data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, data) {
    try {
      const response = await api.put(`/customer-measurements/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/customer-measurements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default customerMeasurementService;
